import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function BottomNav({ activeTab, onTabChange }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [showProfile, setShowProfile] = useState(false);
    const profileRef = useRef(null);
    const discordLinked = user?.discordLinked;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfile(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const navItems = discordLinked
        ? [
            { id: 'snipe-feed', label: 'Feed', icon: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z' },
            { id: 'odds-screen', label: 'Odds', icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6' },
            { id: 'results-tracker', label: 'Tracker', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
            { id: 'discord', label: 'Discord', icon: 'M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z' },
        ]
        : [
            { id: 'discord', label: 'Discord', icon: 'M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z' },
            { id: 'snipe-feed', label: 'Feed', icon: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z' },
            { id: 'odds-screen', label: 'Odds', icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6' },
            { id: 'results-tracker', label: 'Tracker', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
        ];

    return (
        <div className="fixed bottom-0 left-0 right-0 md:hidden" style={{ zIndex: 9999 }}>
            {/* Profile popup */}
            {showProfile && (
                <div ref={profileRef} className="absolute bottom-full right-2 mb-2 w-56 bg-[#0f172a] border border-slate-700/50 rounded-xl shadow-2xl shadow-black/60 overflow-hidden animate-slideUp">
                    <div className="px-4 py-3 border-b border-slate-800/50">
                        <p className="text-[11px] font-mono text-slate-500 uppercase tracking-widest">Account</p>
                        <p className="text-xs font-mono text-slate-300 truncate mt-1">{user?.email || 'Email not found.'}</p>
                    </div>
                    <button
                        onClick={() => { setShowProfile(false); onTabChange('manage-subscriptions'); }}
                        className="w-full flex items-center gap-3 px-4 py-3 text-left text-slate-300 hover:bg-slate-800/50 hover:text-white transition-colors"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                        <span className="text-xs font-mono font-medium">Billing</span>
                    </button>
                    <button
                        onClick={handleLogout}
                        className="w-full flex items-center gap-3 px-4 py-3 text-left text-red-400 hover:bg-red-500/10 transition-colors border-t border-slate-800/50"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        <span className="text-xs font-mono font-medium">Logout</span>
                    </button>
                </div>
            )}

            {/* Bottom bar */}
            <nav className="bg-[#0a0f1e]/95 backdrop-blur-xl border-t border-slate-800/60">
                <div className="flex items-stretch justify-around px-1" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
                    {navItems.map((item) => {
                        const isActive = activeTab === item.id;
                        return (
                            <button
                                key={item.id}
                                onClick={() => onTabChange(item.id)}
                                className={`flex-1 flex flex-col items-center justify-center gap-1 py-3.5 relative transition-colors duration-150 ${
                                    isActive ? 'text-emerald-400' : 'text-slate-500 active:text-slate-300'
                                }`}
                            >
                                {isActive && (
                                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-emerald-500 rounded-full" />
                                )}
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={isActive ? '2.5' : '1.5'} d={item.icon} />
                                </svg>
                                <span className={`text-[9px] font-mono tracking-wide ${isActive ? 'font-semibold' : 'font-medium'}`}>
                                    {item.label}
                                </span>
                            </button>
                        );
                    })}

                    {/* Profile button */}
                    <button
                        onClick={() => setShowProfile(prev => !prev)}
                        className={`flex-1 flex flex-col items-center justify-center gap-1 py-3.5 relative transition-colors duration-150 ${
                            showProfile ? 'text-emerald-400' : 'text-slate-500 active:text-slate-300'
                        }`}
                    >
                        {showProfile && (
                            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-emerald-500 rounded-full" />
                        )}
                        <div className={`w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold transition-all ${
                            showProfile
                                ? 'bg-emerald-500 text-white ring-1 ring-emerald-400/50'
                                : 'bg-slate-700 text-slate-400'
                        }`}>
                            {user?.email?.charAt(0).toUpperCase() || 'A'}
                        </div>
                        <span className={`text-[9px] font-mono tracking-wide ${showProfile ? 'font-semibold' : 'font-medium'}`}>
                            Account
                        </span>
                    </button>
                </div>
            </nav>

            <style jsx>{`
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(8px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-slideUp {
                    animation: slideUp 0.15s ease-out forwards;
                }
            `}</style>
        </div>
    );
}

export default BottomNav;
